import React, { useEffect } from "react";
import Router from "./router";
import Aos from "aos";
import UnderConstruction from "./components/UnderConstruction";

// Flip to `false` to bring the regular site back online.
const SITE_UNDER_CONSTRUCTION = true;

function App() {
  useEffect(() => {
    if (!SITE_UNDER_CONSTRUCTION) {
      Aos.init({
        duration: 700,
        easing: "ease-in-out",
        once: false,
      });
    }
  }, []);

  if (SITE_UNDER_CONSTRUCTION) {
    return <UnderConstruction />;
  }

  return <Router />;
}

export default App;
